var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row gfol" }, [
    _c("div", { staticClass: "green-fitout__header small-12" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("tenantProjects.guideline")) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "small-12" },
      [
        _c("PostFitOutGuideline", {
          staticClass: "green-fitout__body guidelines",
          attrs: { guidelines: _vm.publishedGuideLines },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }